<template>
  <div class="products">
    <transition :name="transitionName" mode="out-in">
      <keep-alive :include="keepAliveList">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: "news",
  components: {},
  data() {
    return {
      transitionName: "move",
      keepAliveList: ['keep-alive-page'],

    };
  },
  computed: {
  },
  created() {},
  methods: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue